import script from "./MemberList.vue?vue&type=script&lang=ts&setup=true"
export * from "./MemberList.vue?vue&type=script&lang=ts&setup=true"

import "./MemberList.vue?vue&type=style&index=0&id=35709077&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35709077"]])

export default __exports__